import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useCustomParamId } from 'hooks/useParamId';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiNavigationArrow } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetMerchContractHistory } from 'services/merch/settlementInfo';
import { IMerchMutationForm } from 'services/merch/types';
import { formatDate } from 'utils/global/date.utils';

const MerchContractsHistory = () => {
  const merchId = useCustomParamId('id');

  usePermissionGuard('ContractPermissionsLIST**');

  const { t } = useTranslation();

  const navigate = useNavigate();

  const navigateToNewWindow = useNewWindowNavigate();

  const { status }: IFormikContextType<IMerchMutationForm> =
    useFormikContext<IMerchMutationForm>();

  const history = useGetMerchContractHistory(merchId);

  return (
    <TopbarPage
      topbar={
        <TopBar
          size='compact'
          customBackItem={
            <Button
              isClear
              onlyIcon
              onClick={() =>
                navigate(
                  status?.displayMode
                    ? `/merch/${merchId}/contracts`
                    : `/merch/edit/${merchId}/contracts`
                )
              }>
                            <Button.Description description={t('button.back')} />

                            <Button.Icon icon={<PiCaretLeftBold />} />
            </Button>
          }
        />
      }>
      <Table
        id={"MerchContractsHistory"}
        size='compact'
        loading={history.isLoading}
        data={{
          nodes:
            history.data?.contracts.map(c => ({
              ...c,
              id: c.contractId,
            })) ?? [],
        }}
        columns={[
          {
            label: `${t('input.label.global')}`,
            renderCell: ({ labelName: name }) => (
              <TableItem>
                <TableItem.Text text={name} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t(`input.label.contract`),
            renderCell: contract => (
              <TableItem>
                <TableItem.Text text={contract.contractName} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t(`input.label.date`),
            renderCell: contract => (
              <TableItem>
                <TableItem.Text text={`${formatDate(contract.startDate)}`} />
              </TableItem>
            ),
            resize: true,
          },

          {
            label: t(`input.label.division`),
            renderCell: ({ divisionPercentage, id: index }) => (
              <TableItem>
                <TableItem.Text text={`${divisionPercentage ?? '-'}%`} />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: ({ id: index, labelId, contractId }) => (
              <TableItem justifyPosition='end'>
                <Button
                  isClear
                  onlyIcon
                  onClick={() =>
                    navigateToNewWindow(
                      `label/${labelId}/contract/${contractId}/form`
                    )
                  }>
                                    <Button.Description description={t('button.go-to-form')} />

                                    <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default MerchContractsHistory;
